module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('add-review-meeting-date', {
    attrs: {
      "oldReviewDate": _vm.oldReviewDate,
      "oldActivatingDate": _vm.oldActivatingDate,
      "campaignID": _vm.campaignID,
      "options": {
        theme: 'default'
      }
    },
    on: {
      "updated": _vm.invokeReviewMeetingUpdated,
      "reloadTimeline": _vm.getCampaignTimelines
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pb-2 text-right"
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6",
      "justify": "left",
      "align": "left",
      "pt-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadImage()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("download")]), _vm._v("\n        Download Image\n      ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6",
      "justify": "right",
      "align": "right",
      "pt-0": ""
    }
  }, [(_vm.currentMode === 'view') ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n        Edit Mode\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('view')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n        Cancel\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "",
      "disabled": _vm.disableSave
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("check")]), _vm._v("\n        Save Changes\n      ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    class: ("text-center print-table-inner " + (_vm.currentMode === 'view' ? 'table-view-mode' : 'table-edit-mode'))
  }, [_c('div', {
    attrs: {
      "id": "img-node"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "campaign-timeline-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('draggable', {
          attrs: {
            "list": props.items,
            "tag": "tbody",
            "handle": ".move-cursor"
          },
          on: {
            "update": function($event) {
              return _vm.handleDataTableDragDrop(props.items)
            }
          }
        }, _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: parentIndex
          }, [_c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '20%' : '40%')))
          }, [_c('div', {
            staticClass: "d-flex flex-row justify-left pt-4"
          }, [(_vm.editMode) ? _c('v-icon', {
            staticClass: "move-cursor",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                        mdi-arrow-all\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.viewMode) ? _c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          " + _vm._s(item.startDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row"
          }, [(_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "placeholder": "Start Date",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'startDate', 'validStartDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'startDate', 'validStartDate')
              }
            },
            model: {
              value: (item.startDate),
              callback: function($$v) {
                _vm.$set(item, "startDate", $$v)
              },
              expression: "item.startDate"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [(_vm.editMode) ? _c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.startDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'startDate' ].concat( argsArray ))
              }
            }
          }) : _vm._e()], 1), _vm._v("\n                           "), (_vm.editMode && item.startDate) ? _c('span', {
            class: ("pt-2 " + (_vm.utils.func.getDaysDiff(item.startDate) < 0 ? 'text-red': ''))
          }, [_vm._v("(" + _vm._s(_vm.utils.func.getDaysDiff(item.startDate)) + ")")]) : _vm._e()], 1), _vm._v(" "), (_vm.editMode && !item.validStartDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Start Date")]) : _vm._e()]), _vm._v(" "), ((item.startDate && item.endDate) || _vm.editMode) ? _c('div', {
            class: ("px-2 " + (_vm.editMode ? 'pt-2' : '') + " text-center")
          }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.viewMode) ? _c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          " + _vm._s(item.endDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row"
          }, [(_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "placeholder": "End Date",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'endDate', 'validEndDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'endDate', 'validEndDate')
              }
            },
            model: {
              value: (item.endDate),
              callback: function($$v) {
                _vm.$set(item, "endDate", $$v)
              },
              expression: "item.endDate"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [(_vm.editMode) ? _c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.endDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'endDate' ].concat( argsArray ))
              }
            }
          }) : _vm._e()], 1), _vm._v("\n                           "), (_vm.editMode && item.endDate) ? _c('span', {
            class: ("pt-2 " + (_vm.utils.func.getDaysDiff(item.endDate) < 0 ? 'text-red': ''))
          }, [_vm._v("(" + _vm._s(_vm.utils.func.getDaysDiff(item.endDate)) + ")")]) : _vm._e()], 1), _vm._v(" "), (_vm.editMode && !item.validEndDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid End Date")]) : _vm._e()])], 1), _vm._v(" "), (_vm.editMode && !item.startDate && !item.endDate && item.actionType !== _vm.timelineTypes.EMPTY) ? _c('div', {
            staticClass: "text-danger text-left ma-0 pt-1"
          }, [_vm._v("Please enter start date or end date")]) : _vm._e(), _vm._v(" "), (_vm.showActivatingDueDateBox(item)) ? _c('div', {
            staticClass: "pb-3"
          }, [(_vm.editMode) ? _c('div', [_c('hr', {
            staticClass: "mb-2"
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row pt-3 pb-3"
          }, [(_vm.editMode) ? _c('span', [_vm._v("Enter Date for IMS to remind you on brief due date:")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-text-field', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'activatingDueDate', 'validActivatingDueDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'activatingDueDate', 'validActivatingDueDate')
              }
            },
            model: {
              value: (item.activatingDueDate),
              callback: function($$v) {
                _vm.$set(item, "activatingDueDate", $$v)
              },
              expression: "item.activatingDueDate"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [_c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.activatingDueDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'activatingDueDate' ].concat( argsArray ))
              }
            }
          })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.editMode && !item.validActivatingDueDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Activating Due Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode && !_vm.hideForPrint) ? _c('div', {
            staticStyle: {
              "margin-top": "-15px"
            }
          }, [_c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          Brief Due Date: " + _vm._s(item.activatingDueDate) + "\n                        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPairingDueDateBox(item)) ? _c('div', {
            staticClass: "pb-3"
          }, [(_vm.editMode) ? _c('div', [_c('hr', {
            staticClass: "mb-2"
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row pt-3 pb-3"
          }, [(_vm.editMode) ? _c('span', [_vm._v("Enter Date to prompt CC on lineup due date:")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-text-field', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'pairingDueDate', 'validPairingDueDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'pairingDueDate', 'validPairingDueDate')
              }
            },
            model: {
              value: (item.pairingDueDate),
              callback: function($$v) {
                _vm.$set(item, "pairingDueDate", $$v)
              },
              expression: "item.pairingDueDate"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [_c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.pairingDueDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'pairingDueDate' ].concat( argsArray ))
              }
            }
          })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.editMode && !item.validPairingDueDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Pairing Due Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode && !_vm.hideForPrint) ? _c('div', {
            staticStyle: {
              "margin-top": "-15px"
            }
          }, [_c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          Lineup Due Date: " + _vm._s(item.pairingDueDate) + "\n                        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '45%' : '40%')))
          }, [(_vm.viewMode) ? _c('h4', {
            class: ((item.actionType && item.actionType.value ? 'font-weight-bold' : '') + " mb-1 mt-1"),
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v("\n                      " + _vm._s(_vm.displayActionType(item.actionType)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-combobox', {
            staticClass: "mt-1 mb-1",
            staticStyle: {
              "width": "200px"
            },
            attrs: {
              "label": "",
              "items": _vm.timelineTypeLists,
              "item-text": "title",
              "item-value": "value",
              "dense": "",
              "outlined": "",
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeActionType()
              }
            },
            model: {
              value: (item.actionType),
              callback: function($$v) {
                _vm.$set(item, "actionType", $$v)
              },
              expression: "item.actionType"
            }
          }) : _vm._e(), _vm._v(" "), (_vm.viewMode) ? _c('p', {
            staticClass: "mb-1",
            domProps: {
              "innerHTML": _vm._s(_vm.formatDesc(item.actionDesc))
            }
          }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-textarea', {
            staticClass: "mb-1",
            attrs: {
              "outlined": "",
              "dense": "",
              "rows": "2",
              "hide-details": ""
            },
            model: {
              value: (item.actionDesc),
              callback: function($$v) {
                _vm.$set(item, "actionDesc", $$v)
              },
              expression: "item.actionDesc"
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '25%' : '30%')))
          }, [(_vm.viewMode) ? _c('p', [_vm._v(_vm._s(item.actionBy))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.actionBy),
              callback: function($$v) {
                _vm.$set(item, "actionBy", $$v)
              },
              expression: "item.actionBy"
            }
          }) : _vm._e()], 1), _vm._v(" "), (_vm.editMode) ? _c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "5%"
            }
          }, [_c('v-btn', {
            attrs: {
              "small": "",
              "icon": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.deleteItem(item)
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e()])
        }), 0)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }])
  })], 1)]), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "justify": "left",
      "align": "left",
      "pt-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.addAction
    }
  }, [_c('v-icon', _vm._g({}, _vm.on), [_vm._v("add")]), _vm._v(" Add Action\n        ")], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('linear-progress', {
    attrs: {
      "loading": _vm.isLoading,
      "text": "Generating..."
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b846093c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/Timeline/DataTable.vue
// module id = 2276
// module chunks = 0